import * as React from 'react'
import * as ReactModal from 'react-modal'

// XXX: hack, somehow react modal imported in storybook is exported as default
const ReactModalComponent = (ReactModal as any).default
  ? (ReactModal as any).default
  : ReactModal

export interface Props {
  isOpen: boolean
  onSignUp?: () => void
  onClose?: () => void
}

export default class SignUpPromoteModal extends React.Component<Props> {
  render () {
    return (
      <ReactModalComponent
        isOpen={this.props.isOpen}
        contentLabel='Information Modal'
        onRequestClose={this.props.onClose}
        style={{
          overlay: { zIndex: 20000 },
          content: {
            position: 'absolute',
            left: '50%',
            top: '50%',
            right: 'initial',
            bottom: 'initial',
            transform: 'translate(-50%, -50%)',
            padding: '1.8rem'
          }
        }}>
        <div style={{ fontFamily: 'Roboto, sans-serif' }}>
          <h2 className='my0'>✅ Need to sign up</h2>
          <p>
            Sign up now for <strong>FREE</strong> to be able to
            <ul className='pl3'>
              <li>Post photo 🌉</li>
              <li>Mark photo you love ❤️</li>
              <li>Walking speed boost! 🚀</li>
            </ul>
          </p>
          <button
            className='btn btn-primary'
            style={{ width: '18rem' }}
            onClick={this.props.onSignUp}>
            Sign Up
          </button>
        </div>
      </ReactModalComponent>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SignUpPromoteModal.tsx